import { AccountFacade } from '@mode/accounts/contract';
import { UserTypes } from '@mode/shared/contract-common';
import { Observable } from 'rxjs';

export default class ContextModalController {
  private $close: any;
  private $dismiss: any;
  private homeName: string;
  private account: UserTypes.AuthenticatedUser;
  private context: any;
  private studioText: string;
  private workspaceName: string;
  private workspaceText: string;
  private confirmationModalTitle: string;

  static $inject = ['$window', 'AccountFacade'];

  constructor(
    private $window,
    private accountFacade: AccountFacade
  ) {
    this.studioText = `Before you connect a database, you'll need to create a free Mode Studio workspace. This will let you query and share data privately with others. You can return to the Mode Community at any point.`;
    this.workspaceName = 'Workspace';
    this.confirmationModalTitle = `Creating a ${this.workspaceName}`;
    // not using workspaceName in this string because all the mixed casing/pluralization
    this.workspaceText = `Workspaces allow companies and other groups to share data and analysis privately.\n\nDatabases connected to Workspaces can be queried by everyone in the Workspace. For more information on connecting databases to your Workspace, see Connecting to Databases.\n\nReports, Definitions, and Spaces created using Workspace databases can be shared and run by everyone in the Workspace, depending on how permissions are set by the Workspace's admin.`;
  }

  gotoNewOrganization() {
    this.$window.location.href = this.account.links.newOrganization;
    this.$close();
  }
}
